import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import ListFromTable from 'components/common/ListFromTable'
import * as AppRouter from 'constants/appRouting'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import Sort from 'lib/psfs/Sort'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import {
  fetchUserGroupTable,
  deleteUserGroupInfo,
  clearUserGroupTable,
} from 'reducers/userGroup/reducer'
import DateColumn from 'types/table/DateColumn'
import messages from './translate'

class UserGroupList extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
    this.getTableData = props.fetchUserGroupTable
    this.deleteEntity = props.deleteUserGroupInfo
    this.clearReducerState = props.clearUserGroupTable
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    this.loadingData = nextProps.loader

    const { licenseeId, tableData } = this.props

    if (licenseeId !== nextProps.licenseeId) {
      this.reloadTableData(AppRouter.USER_GROUP_LIST)

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.userGroupList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createUserGroup),
      link: AppRouter.USER_GROUP_CREATE,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('users', formatMessage(messages.users), {
        render: ({ users }) => users.map(user => user.name).join(', '),
      }),
    )
    columns.add(
      new Column('sites', formatMessage(messages.sites), {
        render: ({ sites }) =>
          sites.length
            ? sites.map(site => site.name).join(', ')
            : formatMessage(messages.all),
      }),
    )
    columns.add(
      new Column('applications', formatMessage(messages.applications), {
        render: ({ applications }) =>
          applications.map(application => application.appName).join(', '),
      }),
    )
    columns.add(
      new DateColumn('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
      }),
    )

    return columns
  }

  getActions() {
    const {
      history,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.editUserGroup), ({ id }) => {
        history.push(UrlHelper.create(AppRouter.USER_GROUP_EDIT, { id }))
      }),
    )
    actions.add(
      new Action(
        'delete',
        formatMessage(messages.deleteUserGroup),
        ({ id }) => {
          this.onOpenConfirmDialog({
            entityId: id,
            psfs: this.psfs,
          })
        },
      ),
    )

    return actions
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteUserGroup),
      message: formatMessage(messages.deleteUserGroupMessage),
    }
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['userGroup', 'tableData']),
    loader: state.getIn(['userGroup', 'isLoadTable']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
  }),
  {
    fetchUserGroupTable,
    deleteUserGroupInfo,
    clearUserGroupTable,
  },
)(injectIntl(UserGroupList))
